function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M7.04 4.293a1 1 0 0 1 1.414 1.414L6.067 8.094a1 1 0 0 1-1.414 0l-1.36-1.36A1 1 0 0 1 4.707 5.32l.653.653 1.68-1.68z"
});

var SvgCheckmark = function SvgCheckmark(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _ref);
};

export default SvgCheckmark;


//////////////////
// WEBPACK FOOTER
// ./src/icons/checkmark.svg
// module id = 269
// module chunks = 0 1